import { Answer } from 'types';

export default function getItemAnswer(
  itemId: string,
  answers: Answer[],
): Answer | undefined {
  return answers.find(({ item_id }) => item_id === itemId);
}
